import { PlayerClassType } from "../../enum/PlayerClassType";
import { MetersToUnits, toPixels } from "../../util";
import Player from "../Player";
import PlayerClass from "../PlayerClass";
import Gun from "../Gun";
import BoostThrusters from "../abilities/scout/BoostThrusters";
import SensorSweep from "../abilities/scout/SensorSweep";
import DecoyDrone from "../abilities/scout/DecoyDrone";
import ScatterRifle from "../guns/scout/ScatterRifle";
import EMPDart from "../guns/scout/EMPDart";

export default class Scout extends PlayerClass {

    constructor(player: Player) {
        super(PlayerClassType.Scout, player, new ScatterRifle(player), new EMPDart(player));

        this.player.hp = this.player.maxHp = 650;
        this.player.energy = this.player.maxEnergy = 90;
        this.player.accelerationForce = toPixels(MetersToUnits(125));
        this.player.size = 7;

        this.abilities = [
            new BoostThrusters(this.player),
            new SensorSweep(this.player),
            new DecoyDrone(this.player)
        ];
    }

    Draw(color: string): void {
        this.ctx.strokeStyle = color;
        this.ctx.fillStyle = color + "55";
        this.ctx.lineWidth = 1;

        //draw player
        const p1 = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size));
        const p2 = this.player.transform.position.add(this.player.transform.right.rotate(Math.PI/4).scale(this.player.size));
        const p3 = this.player.transform.position.add(this.player.transform.back.scale(this.player.size/4));
        const p4 = this.player.transform.position.add(this.player.transform.left.rotate(-Math.PI/4).scale(this.player.size));

        this.player.engine.fillShape(p1, p2, p3, p4);
        this.player.engine.strokeShape(p1, p2, p3, p4);
        //

        super.Draw(color);
    }

}